import React from 'react';
import Modal from "react-modal";
import { bulkPayoutForDoctors } from '../../services/api/online-payment';
import FileSaver from 'file-saver';
import jsonToCsv from '../../utils/jsonToCsv';

// const customStyles = {
//     table : {
//            width: '600px',
//            display: 'flex',
//            flexDirection: 'column',
//            justifyContent: 'center',
//     }
// };


export default class PayoutBulkUploadModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            payoutResponse: [],
        };
    }

    handlePayoutBulkUpload = (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) {
            alert('Please select a file to upload.');
            return;
        }
        const formData = new FormData();
        formData.append('file', file);
        bulkPayoutForDoctors(formData)
            .then((response) => {
                if (response.message === 'serverError') {
                    alert(response.errorMessage || 'Something went wrong. Please try again later.');
                } else {
                    alert(response?.data || 'Payouts processed successfully');
                }
            })
            .catch((error) => {
                console.error('Error uploading file:', error);
                alert(error.errorMessage || 'Error uploading file. Please try again later.');
            }).finally(() => {
                document.querySelector('#payoutBulkUpload').value = null;
            }
            );
    };
    onClose = () => {
        this.setState({
            isOpen: false,
        });
    };

    downloadCsv = (jsonArray, fileName) => {
        jsonArray = jsonArray.filter(item => !item.success); 
        const csv = jsonToCsv(jsonArray);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
        FileSaver.saveAs(blob, fileName);
    };


    render() {
        return (
            <React.Fragment>
                <div className="btn btn-primary" onClick={() => { document.querySelector('#payoutBulkUpload').click() }}> <input
                    type="file"
                    id="payoutBulkUpload"
                    accept=".csv"
                    style={{ display: 'none' }}
                    onChange={this.handlePayoutBulkUpload}
                />
                    Bulk Upload Payout
                </div>
                <Modal
                    isOpen={this.state.isOpen}
                    onRequestClose={this.onClose}
                >
                    <h4>Payout Response</h4>
                    {this.state.payoutResponse.length > 0 ? (
                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            <table className="table" style={{}}>
                                <thead>
                                    <tr>
                                        <th>Doctor ID</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.payoutResponse.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.doctorId}</td>
                                            <td>{item.success ? "Success" : item.errorMessage}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p>No payout data available.</p>
                    )}
                    <div className='d-flex flex-row justify-content-between align-items-center'>
                        <button className="btn btn-secondary" onClick={this.onClose}>Close</button>
                        <button
                            className="btn btn-primary"
                            onClick={() => this.downloadCsv(this.state.payoutResponse, 'failed_payouts.csv')}
                        >
                            Download Failed Payouts
                        </button>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
